import React from 'react';
import DrgCodesGrid from '../../grids/contractGrids/DrgCodesGrid';

const CodesTab: React.FC = () => {
  return <DrgCodesGrid />;
};

export default CodesTab;
